// PRODUCT-26110 Phase 2B2: 'vue-router/types/router' is a vue-router-3-only subpath,
// not present in v4's `exports` map at all -- module-not-found, not just a type
// mismatch. `RawLocation` -> `RouteLocationRaw`.
import type { RouteLocationRaw } from 'vue-router';

import { TransitionState } from '@/utils/getTransitionState';

const transitionRoutes: Record<TransitionState, RouteLocationRaw> = {
    request: { name: 'overview' },
    payment: { name: 'checkout' },
    finishing: { name: 'finishing' },
    finished: { name: 'thank-you' },
    lookup: { name: 'status' },
};

export default function getTransitionRoute(transitionState: TransitionState): RouteLocationRaw {
    return transitionRoutes[transitionState];
}
